var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvalidFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#FFC4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7902 13.3166C14.7902 12.5029 14.1304 11.8431 13.3167 11.8431C12.503 11.8431 11.8432 12.5029 11.8432 13.3166C11.8432 14.1303 12.503 14.7901 13.3167 14.7901C14.1304 14.7901 14.7902 14.1303 14.7902 13.3166ZM16.2632 13.3166C16.2632 14.944 14.9441 16.2631 13.3167 16.2631C11.6893 16.2631 10.3702 14.944 10.3702 13.3166C10.3702 11.6892 11.6893 10.3701 13.3167 10.3701C14.9441 10.3701 16.2632 11.6892 16.2632 13.3166Z",
    fill: "#E7000B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1566 12.5801C22.5635 12.5801 22.8931 12.9097 22.8931 13.3166C22.8931 13.7234 22.5635 14.0531 22.1566 14.0531H15.5266C15.1198 14.0531 14.7902 13.7234 14.7902 13.3166C14.7902 12.9097 15.1198 12.5801 15.5266 12.5801H22.1566Z",
    fill: "#E7000B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1569 20.6838C22.1569 19.8701 21.4971 19.2103 20.6834 19.2103C19.8697 19.2103 19.2099 19.8701 19.2099 20.6838C19.2099 21.4975 19.8697 22.1573 20.6834 22.1573C21.4971 22.1573 22.1569 21.4975 22.1569 20.6838ZM23.6299 20.6838C23.6299 22.3112 22.3108 23.6303 20.6834 23.6303C19.056 23.6303 17.7369 22.3112 17.7369 20.6838C17.7369 19.0564 19.056 17.7373 20.6834 17.7373C22.3108 17.7373 23.6299 19.0564 23.6299 20.6838Z",
    fill: "#E7000B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4734 19.9473C18.8802 19.9473 19.2098 20.2769 19.2098 20.6838C19.2098 21.0906 18.8802 21.4202 18.4734 21.4202H11.8434C11.4365 21.4202 11.1069 21.0906 11.1069 20.6838C11.1069 20.2769 11.4365 19.9473 11.8434 19.9473H18.4734Z",
    fill: "#E7000B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidFilterIcon);
export default __webpack_public_path__ + "static/media/invalid-filter-icon.4ea20a7a3053ddb23f35c0d909e88e20.svg";
export { ForwardRef as ReactComponent };